
import polygon from '../../assest/ahbaab/aboutbg.jpg'
import { Box, Button } from "@mui/material"
import img1 from '../../assest/ahbaab/Personal Protection.jpg'
import img2 from '../../assest/ahbaab/lab-5.jpg'
import '../../styles/ahbaab/AboutUsStyle.css'
import { Link } from 'react-router-dom'
import Header from '../../common/ahbaab/Header/Header'
import Footer from '../../common/ahbaab/Footer/Footer'
import { FaSquareArrowUpRight } from 'react-icons/fa6'
import AboutusData from '../../data/ahbaab/AboutusData'
import ValuesData from '../../data/ahbaab/ValuesData'




const AboutUs = () => {

    return (
        <>
            <Header />

            <Box className='Aboutus_topdiv'>
                <img src={polygon} alt="img" />
                <div className="hosp_aboutushead">
                    <h1>About Us</h1>
                </div>
            </Box>

            <Box className='Qu_about_div'>
                <Box className="Qu_about_div_home row">
                    <div className="imggdiv col-lg-6 col-12">
                        <img src={img1} alt="img" />
                    </div>
                    <div className="textdiv col-lg-6 col-12">
                        <h6>About Us</h6>
                        <p>At Qu-lucency, we are dedicated to supporting pharmaceutical excellence with high-quality cleanroom consumables, defect kits, and a comprehensive range of precision products. Our solutions are designed to meet the stringent standards of the pharmaceutical industry ensuring safety, reliability, and consistency. With a commitment to quality and customer satisfaction, we help our clients maintain clean, compliant, and efficient operations.</p>
                    </div>
                </Box>
            </Box>


            <div className="Expert_div">
                <div className="Expert_slidediv">
                    {AboutusData?.map((item, index) => (
                        <div key={item.id} className="Expert_div_slide">
                            <img src={item.imgSrc} alt={`img-${item.id}`} />
                            <h4>{item.heading}</h4>
                            <p>{item.textdetail}</p>
                        </div>
                    ))}
                </div>
            </div>


            <Box className='Qu_about_div'>
                <Box className="Qu_about_div_home row">

                    <div className="textdiv col-lg-6 col-12">
                        <h6>Customer Support</h6>
                        <p>QU-Lucency Private Limited offers a dedicated customer support team available to assist with product recommendations, technical support, and any inquiries.</p>
                        <Link to={'/contact-us'}><Button className="morebtn-cont">Contact Us <FaSquareArrowUpRight className=" ms-2 fs-5" /></Button></Link>
                    </div>

                    <div className="imggdiv col-lg-6 col-12">
                        <img src={img2} alt="img" />
                    </div>
                </Box>
            </Box>


            <div className="Expert_div">
                <h1 className=" fw-bold py-3">Core values</h1>
                <div className="Expert_slidediv">
                    {ValuesData?.map((item, index) => (
                        <div key={item.id} className="Expert_div_slide">
                            <img src={item.imgSrc} alt={`img-${item.id}`} />
                            <h4>{item.heading}</h4>
                            <p>{item.textdetail}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />

        </>
    )
}

export default AboutUs